<template>
  <div class="video">
    <div id="remote" class="remote"></div>
    <!-- <img v-show="false" id="orgImg" src="https://img.webloom.cn/img/1.jpg" />
    <img v-show="false" class="photo" id="detImg" src="https://img.webloom.cn/img/1.jpg" /> -->
    <canvas v-show="false" id="canvas"/>
    <BloomDialog
      style="z-index: 99999"
      :show.sync="browserVideoVisible"
      :closeOnClickModal="false"
      @close="closeChrome"
      :hasCloseIcon="false"
      width="400"
      top="300px">
      <div style="font-size: 16px; word-break: break-word">
        {{$t('bloomTest00121')}}
      </div>
      <div class="btn-video-dialog cursor" @click="closeChrome">
        {{$t('bloomTest00018')}}
      </div>
    </BloomDialog>
    <BloomDialog
      style="z-index: 99999"
      :show.sync="openVideoVisible"
      :closeOnClickModal="false"
      @close="closeChrome"
      :hasCloseIcon="false"
      width="600"
      top="150px">
      <div class="el-dialog__header title bold">{{$t('bloomTest00131')}}</div>
      <div class="dialog__body" style="font-size: 16px; word-break: break-word">
        <div>{{$t(microphone == 0 ? 'bloomTest00149' : 'bloomTest00150')}}</div>
        <img class="cmImg" :src="$t(microphone == 0 ? 'bloomTest00151' : 'bloomTest00152')" alt="" srcset="">
      </div>
      <div class="dialog-footer cancelBtn cursor" @click="openVideoVisible = false">
        {{$t('bloomTest00133')}}
      </div>
    </BloomDialog>
  </div>
</template>

<script>
import putFile from '@assets/api/js/ali-oss1'
import TRTC from 'trtc-js-sdk'
import { mapState } from 'vuex'
import BloomDialog from '@public/bloom-dialog'
import uaParserJs from 'ua-parser-js'
const uaParser = uaParserJs()
const { browser } = uaParser

export default {
  name: 'videoCmp',
  props: {
    isNeedShoot: {
      type: Boolean,
      default: true
    },
    isNeedShowD: {
      type: Boolean,
      default: true
    },
    examId: {},
    videoRoomInfo: {},
    sdkAppId: {},
    imgType: {
      type: String,
      default: 'examMnitor'
    },
    microphone: {
      type: Number,
      default: 0
    },
    userPhoto: {
      type: String,
      default: ''
    },
    reviewIdentity: {
      type: Number,
      default: 0
    }
  },
  components: {
    BloomDialog
  },
  computed: mapState({
    shareClient: state => state.test.shareClient,    // 屏幕分享客户端
    shareStream: state => state.test.shareStream    // 屏幕分享客户端
  }),
  data () {
    return {
      videoStatus: -1,
      videoMinutes: 1,
      userId: '',
      client: null,
      stream: null,
      timer: '',
      timer2: '',
      jionEdRoom: false,
      openVideoVisible: false,
      imgVisible: false,
      stoped: false,
      roomInfo: {
        endTime: '',
        playUrl: '',
        sdkAppId: '',
        streamId: '',
        tlsUserId: '',
        videoRoomId: ''
      },
      options: null,
      timerOut: null,
      browserVideoVisible: false,
      nets: 'tinyFaceDetector',
      localTimer: null,
      bytesSent: 0,
      blo: false // 是否开启麦克风
    }
  },
  methods: {
    // 将初始学生的图片转为base64，用于人脸识别
    funcHttpsToBase64 (img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    async showStudentImg () {
      let self = this
      var img = document.createElement('img')
      img.src = this.userPhoto
      img.crossOrigin = 'anonymous'
      img.onload = function () {
        var data = self.funcHttpsToBase64(img)
        let orgImgEl = document.getElementById('orgImg')
        orgImgEl.src = data
      }
    },
    sendProctor (data) {
      data.transactionId = this.$route.query.examId
      try {
        this.$api.postNoLoading('TEST_EXAM_TRANSACTION', data, res => {
          if (res && res.data && res.data.subPictureTime) {
            // 判断后端返回的截图时间，是否和当前截图时间相同，不同则修改定时截图的时间
            if (res.data.subPictureTime !== this.videoMinutes) {
              clearInterval(this.timer)
              this.$utils.cache(`${this.$route.query.examId}videoMinutes`, res.data.subPictureTime)
              if (res.data.subPictureTime < 1) return
              this.timer = setInterval(async () => {
                this.shotScrean(this.stream).then(file => {
                  let data = {
                    'transactionId': this.$route.query.examId,
                    'transactionType': 4,
                    'transactionFileInfo': file.res.md5name,
                    'fileId': file.res.fileId
                  }
                  this.sendProctor(data)
                })
              }, (60000 * res.data.subPictureTime).toFixed())
            }
          }
        })
      } catch (error) {
        
      }
    },
    // 上报推流状态
    updateVideoStatus (videoStatus, videoRecordDesc) {
      if (this.videoStatus === videoStatus) return
      this.videoStatus = videoStatus
      let data = {
        examId: this.$route.query.examId,
        videoStatus,
        videoType: 1,
        videoRecordDesc,
        videoRecordTime: Date.now()
      }
      this.$api.postNoLoading('TEST_UPDATEVIDEOSTATUS', data, (res) => {})
    },
    // 创建本地视频流 并自动播放
    creatClitnt () {
      let roomInfo = sessionStorage.getItem('RoomInfo')
      if (roomInfo) {
        this.roomInfo = JSON.parse(roomInfo)
      }
      let blo = false //  是否开启麦克风
      if (this.microphone === 1) {
        blo = true
        this.blo = true
      }
      const localStream = TRTC.createStream({ userId: this.roomInfo.tlsUserId, audio: blo, video: true })
      // 初始化 this.stream 立刻指向本地流
      this.stream = localStream
      let div = document.getElementById(`remote`)
      // 如果div中存在多个子节点，删掉该子节点，防止得到多个视频流渲染框
      if (div && div.children.length > 0) {
        for (let j = 0; j < div.children.length; j++) {
          div.removeChild(div.childNodes[j])
        }
      }
      localStream.play(div, {
        objectFit: 'cover',
        muted: true
      }).then(() => {}).catch((e) => {
        // this.$emit('error', '该浏览器不支持调取摄像头，请使用chrome浏览器')
        if (this.stoped) {
          this.checkAlert()
        }
        const errorCode = e.getCode() || 0
        if (errorCode === 0x4043) {
          // PLAY_NOT_ALLOWED,引导用户手势操作恢复音视频播放
          localStream.resume()
        }
      })
      this.initionSteam()
      localStream.on('player-state-changed', event => {
        console.warn(`${event.type} player is ${event.state} because of ${event.reason}`)
        if (event.state === 'PAUSED' || event.state === 'STOPPED') {
          let str = '摄像头连接后中途损坏或被拔出'
          let e = 'bloomTest00120'
          if (this.blo) {
            e = 'bloomTest00125'
            str = '摄像头或麦克风连接后中途损坏或被拔出'
          }
          this.$api.logPost({a: 72004, c: '无法检测到摄像头或麦克风', r: '/', e: str + `${event.type} player is ${event.state} because of ${event.reason}`, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
          this.sendTextLog(str)
          this.$emit('vedioError', e)
        }
        // 麦克风或者视频中断
        if (this.jionEdRoom === true) {
          if (event.state === 'PAUSED' || event.state === 'STOPPED') {
            // 考试结束或交卷以后不调用推流状态更改
            if (!JSON.parse(this.$utils.cache(`${this.$route.query.examId}${this.$utils.cache('userData').userId}updateStatus`))) return
            this.updateVideoStatus(2, '视频中断或者暂停')
            this.localTimer && clearInterval(this.localTimer)
            this.stoped = true
            this.timer && clearInterval(this.timer)
            this.closeVideo()
            if (event.type === 'video') {
              this.checkAlert()
              // 提示视频中断
            } else if (event.type === 'audio') {
              // 提示音频中断bloomTest00124
              this.checkAlert('bloomTest00124')
            }
          }
        } else {
          if (this.stoped) {
            let e = null
            if (this.blo) {
              e = 'bloomTest00126'
            }
            this.checkAlert(e)
          }
        }
      })
    },
    checkAlert (e) {
      if (!this.$store.state.test.examConfig || this.$store.state.test.examConfig.cameraController === 1) {
        this.$_Alter({
          data: {
            text: e ? this.$t(e) : this.$t('bloomTest00107'),
            // 请重新开启摄像头
            yesTxt: this.$t('bloomTest00018'),
            title: '',
            click: () => {
            // window.location.reload
            }
          }
        })
      }
    },
    initionSteam (localStream = this.stream) {
      localStream
        .initialize()
        .then(() => {
          this.$emit('canGo')
          
          localStream.on('error', error => {
            const errorCode = error.getCode()
            if (errorCode === 0x4043) {
              // 自动播放受限，引导用户手势操作并调用 stream.resume 恢复音视频播放
              // 参考：https://web.sdk.qcloud.com/trtc/webrtc/doc/zh-cn/module-ErrorCode.html#.PLAY_NOT_ALLOWED
            } else if (errorCode === 0x4044) {
              // 媒体设备被拔出后自动恢复失败，参考：https://web.sdk.qcloud.com/trtc/webrtc/doc/zh-cn/module-ErrorCode.html#.DEVICE_AUTO_RECOVER_FAILED
              localStream.on('error', async error => {
                if (error.getCode() === 16452) {
                  const newStream = TRTC.createStream({ userId: this.userId, audio: true, video: true })
                  try {
                    newStream.initialize().then(res4 => {
                      // 获取摄像头和麦克风 track
                      const videoTrack = newStream.getVideoTrack()
                      const audioTrack = newStream.getAudioTrack()
                      // 分别替换摄像头和麦克风 track
                      localStream.replaceTrack(videoTrack)
                      localStream.replaceTrack(audioTrack)
                    })
                  } catch (err) {
                    // 采集失败，可让用户检查摄像头、麦克风后重试该流程，initialize error 可参考：https://web.sdk.qcloud.com/trtc/webrtc/doc/zh-cn/LocalStream.html#initialize
                    this.$api.logPost({a: 72018, c: '初始化视屏流失败', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
                  }
                }
              })
            }
          })
          if (this.isNeedShoot === true) {
            this.joinRoom(localStream)
            // 截图延后的时间
            if (this.videoMinutes !== -1) {
              let s = Math.floor(Math.random() * 60000 + 5000)
              setTimeout(() => {
                this.timer = setInterval(async () => {
                  this.shotScrean(localStream).then(file => {
                    let data = {
                      'transactionId': this.$route.query.examId,
                      'transactionType': 4,
                      'transactionFileInfo': file.res.md5name,
                      'fileId': file.res.fileId
                    }
                    this.sendProctor(data)
                  })
                }, (60000 * this.videoMinutes).toFixed())
              }, s)
            }
          }
        })
        .catch(error => {
          console.error('初始化本地流失败 ' + error)
          // this.sendLog(error)
          if (this.stoped) {
            let e = null
            if (this.blo) {
              e = 'bloomTest00126'
            }
            this.checkAlert(e)
          }
          // 提交考试操作记录 TEST_EXAM_TRANSACTION
          if (String(error).indexOf('The request is not allowed by the user agent or the platform in') > -1) {
            // 当前浏览器不支持，可能是因为用户拒绝了权限
            this.checkAlert('bloomTest00121')
            this.$emit('vedioError', 'bloomTest00121')
            this.sendTextLog(`浏览器不支持摄像头服务(${browser.name} ${browser.version})`)
            this.$api.logPost({a: 72001, c: '浏览器不支持摄像头服务', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
          } else if (String(error).indexOf('failed to connect to remote server via websocket') > -1) {
            // NotAllowedError
            // 无法通过websocket连接到远程服务器（网络不稳定）
            this.sendTextLog('网络不稳定 无法连接')
            this.$api.logPost({a: 72002, c: '无法通过websocket连接到远程服务器', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
            this.$emit('vedioError', 'bloomTest00122')
            this.checkAlert('bloomTest00122')
          } else if (String(error).indexOf('Could not start video source') > -1) {
            // 摄像头被占用 不能初始化
            this.sendTextLog('摄像头被占用')
            this.$api.logPost({a: 72003, c: '摄像头被占用', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
            if (this.isNeedShowD) {
              this.$emit('vedioError', 'bloomTest00118')
              this.checkAlert('bloomTest00118')
            }
          } else if (String(error).indexOf('he request is not allowed by the user agent or the platform in the current context,') > -1) {
            // 浏览器不支持摄像头服务
            if (this.isNeedShowD) {
              this.sendTextLog(`浏览器不支持摄像头服务(${browser.name} ${browser.version})`)
              this.$api.logPost({a: 72001, c: '浏览器不支持摄像头服务', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
            }
          } else if (String(error).indexOf('NotFoundError') > -1) {
            let str = '摄像头未插入或损坏'
            let e = 'bloomTest00120'
            if (this.blo) {
              e = 'bloomTest00125'
              str = '摄像头或麦克风未插入或损坏'
            }
            if (!this.$store.state.test.examConfig || this.$store.state.test.examConfig.cameraController === 1) {
              this.$api.logPost({a: 72004, c: '无法检测到摄像头或麦克风', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
              this.sendTextLog(str)
              // this.checkAlert(e)
              this.$emit('vedioError', e)
              this.$_Alter({
                data: {
                  text: this.$t(e),
                  yesTxt: this.$t('bloomTest00018'),
                  title: '',
                  click: () => {
                    if (this.isNeedShowD) {
                      let examId = this.$route.query.examId
                      let taskRelationId = this.$route.query.taskRelationId
                      if (examId) {
                        this.$router.push(`/ExamSystemIndex?examId=${examId}&taskRelationId=${taskRelationId}`)
                      } else {
                        this.$router.go(-1)
                      }
                    }
                  }
                }
              })
            }
          } else if (String(error).indexOf('NotAllowedError') > -1) {
            let str = '未打开摄像头权限'
            if (this.blo) {
              str = '未打开摄像头或麦克风权限'
            }
            this.sendTextLog(str)
            this.$emit('vedioError', 'openVideoVisible')
            this.openVideoVisible = true
            this.$api.logPost({a: 72005, c: '摄像头权限未打开', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
          } else if (String(error).indexOf('no camera detected') > -1) {
            let str = '摄像头未插入或损坏'
            if (this.blo) {
              str = '摄像头或麦克风未插入或损坏'
            }
            if (!this.$store.state.test.examConfig || this.$store.state.test.examConfig.cameraController === 1) {
              this.sendTextLog(str)
              this.$emit('vedioError', 'bloomTest00125')
              // 需开启摄像头才可进入考试。
              this.$_Alter({
                data: {
                  text: this.$t('bloomTest00125'),
                  yesTxt: this.$t('bloomTest00018'),
                  title: '',
                  click: () => {
                    if (this.isNeedShowD) {
                      let examId = this.$route.query.examId
                      let taskRelationId = this.$route.query.taskRelationId
                      // 有examId是考试 没有是写作
                      if (examId) {
                        this.$router.push(`/ExamSystemIndex?examId=${examId}&taskRelationId=${taskRelationId}`)
                      } else {
                        this.$router.go(-1)
                      }
                    }
                  }
                }
              })
            }
          } else if (String(error).indexOf('no microphone detected') > -1) {
            let str = '麦克风未插入或损坏'
            if (!this.$store.state.test.examConfig || this.$store.state.test.examConfig.cameraController === 1) {
              this.sendTextLog(str)
              this.$emit('vedioError', 'bloomTest001252')
              // 需开启摄像头才可进入考试。
              this.$_Alter({
                data: {
                  text: this.$t('bloomTest001252'),
                  yesTxt: this.$t('bloomTest00018'),
                  title: '',
                  click: () => {
                    if (this.isNeedShowD) {
                      let examId = this.$route.query.examId
                      let taskRelationId = this.$route.query.taskRelationId
                      // 有examId是考试 没有是写作
                      if (examId) {
                        this.$router.push(`/ExamSystemIndex?examId=${examId}&taskRelationId=${taskRelationId}`)
                      } else {
                        this.$router.go(-1)
                      }
                    }
                  }
                }
              })
            }
          } else {
            if (!this.$store.state.test.examConfig || this.$store.state.test.examConfig.cameraController === 1) {
              // console.log(111111111, error)
              this.sendTextLog('未知原因异常，建议关闭该监考设置')
              this.$api.logPost({a: 72006, c: '未知原因的摄像头异常', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
              this.$emit('vedioError', 'bloomTest00138')
              this.$_Alter({
                data: {
                  text: this.$t('bloomTest00138'),
                  yesTxt: this.$t('bloomTest00018'),
                  title: '',
                  click: () => {
                    if (this.isNeedShowD) {
                      let examId = this.$route.query.examId
                      let taskRelationId = this.$route.query.taskRelationId
                      if (examId) {
                        this.$router.push(`/ExamSystemIndex?examId=${examId}&taskRelationId=${taskRelationId}`)
                      } else {
                        this.$router.go(-1)
                      }
                    }
                  }
                }
              })
            }
          }
        })
    },
    // sendLog (errorLog) {
    //   let data = {
    //     cType: 4
    //   }
    //   let logContent = {}
    //   if (this.userId) {
    //     logContent.userId = this.userId
    //   }
    //   let ua
    //   if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
    //   logContent.errorLog = errorLog.message
    //   logContent.ua = ua
    //   data.logContent = logContent
    //   this.$api.limitPost('REPROT_LOG_RECORD', data, res => {})
    // },
    // 加入远端房间
    joinRoom (localStream) {
      let client = {}
      try {
        client = TRTC.createClient({
          mode: 'live',
          sdkAppId: Number(this.roomInfo.sdkAppId),
          userId: this.userId,
          streamId: this.roomInfo.videoStreamId,
          userSig: this.roomInfo.videoUserSig,
          useStringRoomId: true
        })
      } catch (error) {
        this.sendTextLog('用户对象创建失败（学生已通过，仅后台无画面，无需关闭监考设置）')
        this.$api.logPost({a: 72007, c: '创建客户端失败', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
      }
      
      client.on('client-banned', error => {
        console.error('用户被动下线' + JSON.stringify(error))
        let desc = ''
        if (error.reason === 'kick') {
          desc = '用户重复进房下线'
        } else if (error.reason === 'banned') {
          desc = '系统管理员将用户强制下线'
        } else if (error.reason === 'room-disband') {
          desc = '系统管理员通过服务端解散房间'
        } else {
          desc = '未知原因导致用户被动下线'
        }
        // 考试结束或交卷以后不调用推流状态更改
        this.$api.logPost({a: 72008, c: desc, r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
        this.updateVideoStatus(2, desc)
        this.localTimer && clearInterval(this.localTimer)
      })
      client.on('connection-state-changed', event => {
        const prevState = event.prevState
        const curState = event.state
        if (prevState === 'RECONNECTING') {
          if (curState === 'CONNECTED') {
            this.updateVideoStatus(0, '自动重连成功')
          }
        }
        if (prevState === 'CONNECTING') {
          if (curState === 'CONNECTED') {
            this.updateVideoStatus(0, '连接成功')
          }
        }
        if (prevState === 'CONNECTED') {
          if (curState === 'DISCONNECTED') {
            // 考试结束或交卷以后不调用推流状态更改
            if (!JSON.parse(this.$utils.cache(`${this.$route.query.examId}${this.$utils.cache('userData').userId}updateStatus`))) return
            this.updateVideoStatus(2, '连接中断')
            this.localTimer && clearInterval(this.localTimer)
          }
        }
      })

      // 出现错误
      client.on('error', error => {
        console.error('client error observed: ' + error)
        const errorCode = error.getCode()
        this.sendTextLog('未知原因异常，建议关闭该监考设置')
        this.$api.logPost({a: 72010, c: 'trtc SDK返回的错误', r: '/', e: errorCode, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
        client.leave()
        // 考试结束或交卷以后不调用推流状态更改
        if (!JSON.parse(this.$utils.cache(`${this.$route.query.examId}${this.$utils.cache('userData').userId}updateStatus`))) return
        this.updateVideoStatus(2, errorCode)
        this.localTimer && clearInterval(this.localTimer)
      })

      this.client = client
      client
        .join({ roomId: this.roomInfo.videoRoomId, role: 'anchor' })
        .then(() => {
          this.jionEdRoom = true
          client
            .publish(localStream)
            .catch(error => {
              // this.sendLog(error)
              if (this.stoped) {
                this.checkAlert()
              } else {
                this.sendTextLog('推流失败（学生已通过，仅后台无画面，无需关闭监考设置）')
              }
              // NotFoundError
              if (String(error).indexOf('publish timeout') > -1) {
                // 网络原因 推流超时
                this.sendTextLog('网络原因 推流超时')
                this.$api.logPost({a: 72011, c: '本地流发布失败 -- 网络原因 推流超时', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
                this.checkAlert('bloomTest00117')
              }
              if (String(error).indexOf('getTracks') > -1) {
                this.sendTextLog('使用了safari浏览器')
                this.$api.logPost({a: 72011, c: '本地流发布失败 -- 使用了safari浏览器', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
                this.browserVideoVisible = true
              }
            })
            .then(() => {
              this.$emit('canShowMobile', true)
              this.stoped = false
              this.stream = localStream
              // this.$api.logPost({a: 72000, c: '摄像头正常且推流成功', r: '/', e: {}, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
            })
          this.localTimer = setInterval(() => {
            if (!navigator.onLine) this.videoStatus = 2
            client.getLocalVideoStats().then(stats => {
              for (let userId in stats) {
                // console.log('getLocalVideoStats', this.bytesSent, stats[userId].bytesSent)
                if (this.userId === userId && this.bytesSent === stats[userId].bytesSent) {
                  this.updateVideoStatus(2, '连接中断')
                } else if (this.userId === userId && stats[userId].bytesSent > this.bytesSent) {
                  this.updateVideoStatus(0, '连接成功')
                  this.bytesSent = stats[userId].bytesSent
                }
              }
            })
          }, 3000)
        })
        .catch(error => {
          // this.sendLog(error)
          this.sendTextLog('加入TRTC房间失败（学生已通过，仅后台无画面，无需关闭监考设置）')
          this.$api.logPost({a: 72012, c: '学生进房失败', r: '/', e: error, uid: this.userId, examId: this.$route.query.examId, ua: navigator.userAgent})
        })
    },
    // 定时上传截图
    shotScrean (stream = this.stream) {
      return new Promise((resolve, reject) => {
        let frame = stream.getVideoFrame()
        if (frame && frame.length > 100) {
          let childe = 0
          if (this.microphone === 1) {
            childe = 1
          }
          let videoEl = document.getElementById('remote').childNodes[0].childNodes[childe]
          let canvas1 = document.getElementById('canvas')
          canvas1.width = videoEl.scrollWidth
          canvas1.height = videoEl.scrollHeight
          let ctx = canvas1.getContext('2d')
          ctx.drawImage(videoEl, 0, 0, videoEl.scrollWidth, videoEl.scrollHeight)
          frame = canvas1.toDataURL(['image/jpeg'])
          let name = (Math.random() * 99999999).toFixed(0)
          let file = this.$utils.dataURLtoFile(frame, `${name}_1.jpeg`)
          file.dir = 'exam/behavior/'
          let form = new FormData()
          form.append('fileData', file)
          form.append('examId', this.$route.query.examId)
          // 上传摄像头截图
          putFile({examId: this.$route.query.examId, userId: this.userId}, 'put', file, () => {}).then((res) => {
            resolve(res)
          }).catch(err => {
            console.warn(err)
            reject(err)
          })
        }
      })
    },
    // 行为记录
    switchFn (type, fileInfo = '', fileId = '') {
      if (!this.blurBol) return
      let obj = {
        transactionType: type,
        transactionId: this.examId,
        transactionFileInfo: fileInfo,
        fileId
      }
      try {
        this.$api.postNoLoading('TEST_EXAM_TRANSACTION', obj, (res) => {})
      } catch (err) {

      }
    },
    // 获取房间参数信息
    async getRoomInfo (type = 1) {
      this.roomInfo = {
        ...this.videoRoomInfo, sdkAppId: this.sdkAppId
      }
      this.creatClitnt()
    },
    closeVideo () {
      this.stream && this.stream.close()
    },
    // 检查视频状态
    checkVidoeStatus () {
      this.timer2 = setInterval(() => {
        if (this.stoped === true) {
          this.closeVideo()
          this.client && this.client.leave().catch(err => {
            console.warn('err', err)
          })
          this.getRoomInfo(2)
        }
      }, 60000)
    },
    openImgDialog () {
      this.openVideoVisible = false
      this.$nextTick(() => {
        this.imgVisible = true
      })
    },
    closeChrome () {
      this.browserVideoVisible = false
      this.$forceUpdate()
    },
    // 提交考试操作记录
    sendTextLog (transactionDesc) {
      // try 一下保证发送日志不报错阻塞代码执行
      try {
        let examId = this.$route.query.examId
        let data = {
          transactionId: examId,
          transactionType: 9,
          transactionDesc
        }
        if (examId) {
          // 有id才发送日志
          this.$api.postNoLoading('TEST_EXAM_TRANSACTION', data, (res) => {})
        }
      } catch (err) {

      }
    }
  },
  created () {
    if (this.$utils.cache('userData')) {
      this.userId = JSON.parse(this.$utils.cache('userData')).userId
    }
  },
  mounted () {
    this.videoMinutes = JSON.parse(this.$utils.cache(`${this.$route.query.examId}videoMinutes`)) || 1
    if (this.videoRoomInfo && this.videoRoomInfo.videoStatus === 0 && !this.stream && this.isNeedShowD) {
      this.updateVideoStatus(2, '连接中断')
    }
    setTimeout(res => {
      this.getRoomInfo()
      this.checkVidoeStatus()
    }, 0)
  },
  beforeDestroy () {
    // 组件销毁 注销客户端 关闭本地流 清除定时器
    this.client && this.client.leave().catch(err => {
      console.warn('err', err)
    })
    
    this.closeVideo()
    this.timer && clearInterval(this.timer)
    this.timer2 && clearInterval(this.timer2)
    this.timeOut && clearTimeout(this.timeOut)
    this.localTimer && clearInterval(this.localTimer)
    sessionStorage.clear('RoomInfo')
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .title{
    padding: 20px 20px 10px 40px !important;
    padding-left: 40px !important;
    border-bottom: 1px solid #D8D8D8 !important;
    font-size: 20px !important;
    color: #030A17 !important;
    letter-spacing: 0 !important;
    font-weight: bold !important;
    text-align: left !important;
  }
  /deep/ .el-dialog{
    padding: 0 !important;
    padding-bottom: 40px !important;
  }
  /deep/ .dialog__body{
    padding: 30px 48px 30px 40px !important;
    font-size: 16px !important;
    color: #030A17 !important;
    letter-spacing: 0 !important;
    word-break: break-word !important;
  }
  /deep/ .cmImg{
    margin-top: 24px !important;
    width: 510px !important;
  }
  /deep/ .dialog-footer{
    text-align: center !important;
  }
  /deep/ .cancelBtn{
    margin: auto !important;
    font-size: 16px !important;
    color: #FFFFFF !important;
    letter-spacing: 0 !important;
    background: #296BFF !important;
    border-radius: 4px !important;
    width: fit-content !important;
    padding: 9px 32px !important;
  }
.video {
  width: 316px;
  height: 180px;
  .remote {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
.text-video-fz16 {
  font-size: 16px;
  line-height: 1.8em;
  .underline {
    text-decoration: underline;
  }
}
.btn-video-dialog {
  margin: 32px auto 0;
  text-align: center;
  width: 120px;
  height: 40px;
  border-radius: 40px;
  background: #296bff;
  line-height: 40px;
  color: #fff;
  font-weight: bold;
}
.head-video-dialog {
  position: sticky;
  top: 0;
  color: #296bff;
  font-size: 22px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E7EBF5;
}
.img-container-box {
  height: 460px;
  width: 680px;
  margin-top: 20px;

  overflow: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: block;
    width: 6px;
    height:6px;
    // background-color:#fff;
  }
  &::-webkit-scrollbar-track {
    // box-shadow:inset 0 0 6px rgba(0,0,0,0.3);
    // -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);
    border-radius:10px;
    // background-color:#fff;
  }
  &::-webkit-scrollbar-thumb
    {
        border-radius:10px;
        box-shadow: inset 0 0 6px #E2e2e6;
        -webkit-box-shadow:inset 0 0 6px #E2e2e6;
        // background-color:#555;
        background: #E2e2e6;
    }
  .img-container-imgbox {
    width: 630px;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/video.vue